module.exports = __webpack_public_path__ + "img/p23.11348b4a.png";